import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import LoansTable from './components/LoansTable';
import SkillsTable from './components/SkillsTable';
import WorkshopsTable from './components/WorkshopsTable';
import UsersTable from './components/UsersTable';
import Login from './components/Login';
import ExhibitionsTable from './components/ExhibitionsTable';
import SliderManager from './components/SliderManager'; // <--- IMPORT THIS

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const loggedIn = localStorage.getItem('isAdminLoggedIn');
    if (loggedIn === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = () => setIsAuthenticated(true);
  const handleLogout = () => {
    localStorage.removeItem('isAdminLoggedIn');
    setIsAuthenticated(false);
  };

  return (
    <Router>
      <div className="App">
        {isAuthenticated && <Navbar onLogout={handleLogout} />}
        <Routes>
          {!isAuthenticated ? (
            <Route path="*" element={<Login onLogin={handleLogin} />} />
          ) : (
            <>
              <Route path="/" element={<Navigate to="/loans" />} />
              <Route path="/loans" element={<LoansTable />} />
              <Route path="/skills" element={<SkillsTable />} />
              <Route path="/workshops" element={<WorkshopsTable />} />
              <Route path="/exhibitions" element={<ExhibitionsTable />} />
              
              {/* --- NEW ROUTE --- */}
              <Route path="/sliders" element={<SliderManager />} />
              {/* ----------------- */}

              <Route path="/users" element={<UsersTable />} />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
}

export default App;